<template>
  <div>
    <div class="mb-4 flex items-center">
      <CustomButton icon="arrow_back" iconPosition="left" @click="handleBackToList" :button-text="t('entity.backToList')" size="sm" color="secondary"/>
    </div>
    <ContentReview @content-updated="handleContentUpdated" @back-to-list="handleBackToList"/>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useContentStore } from '@/stores/content'
import { useAssetStore } from '@/stores/asset'
import { useI18n } from 'vue-i18n'
import ContentReview from './reviewContent/index.vue'
import CustomButton from '@/components/base/buttons/VButton.vue'

defineOptions({
  inheritAttrs: false,
})

const emit = defineEmits(['content-updated', 'back-to-list'])

const router = useRouter()
const contentStore = useContentStore()
const assetStore = useAssetStore()
const { t } = useI18n()

// Component yüklenirken asset değişikliğini kontrol et
onMounted(() => {
  // Asset ID'nin değişip değişmediğini kontrol et
  if (contentStore.hasAssetChanged(assetStore.assetId)) {
    // Asset değiştiğinde debug bilgisi
    if (process.env.VUE_APP_MODE === 'development') {
      console.log('ContentDetailWrapper: Asset değişikliği tespit edildi, içerik listesine dönülüyor')
    }
    
    // İçerik listesine geri dön
    handleBackToList()
  }
  
  // Yeni Asset ID'yi kaydet
  contentStore.updateAssetId(assetStore.assetId)
})

const handleContentUpdated = () => {
  emit('content-updated')
}

const handleBackToList = () => {
  // Store'dan içerik ID'sini temizle
  contentStore.clearSelectedContent()
  
  // Sadece tab parametresini al
  const { tab } = router.currentRoute.value.query;
  
  // Sadece gerekli parametreleri içeren yeni query oluştur
  const newQuery = tab ? { tab } : {};

  // Route'u güncelle - sadece gerekli parametreleri koru
  router.push({ query: newQuery })

  // Parent'a bildir
  emit('back-to-list')
}
</script>
